import { render, staticRenderFns } from "./iconBase.vue?vue&type=template&id=f73ff3b6&scoped=true"
import script from "./iconBase.vue?vue&type=script&lang=js"
export * from "./iconBase.vue?vue&type=script&lang=js"
import style0 from "./iconBase.vue?vue&type=style&index=0&id=f73ff3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73ff3b6",
  null
  
)

export default component.exports